<div class="unrecoverable-error-container">
    <div class="container vertical-center">
      <div class="row justify-content-center w-100">
        <div class="col-xl-5 col-lg-6 col-md-7 col-sm-10 col-10">
          <img id="nice-img" src="assets/images/nice-logo-black-with-white.png"/>
          <div class="card rounded-0">
            <div class="card-body">
              <div id="status-failed">
                <img id="status-failed-img" src="assets/images/status_failed.svg"/>
              </div>
              <div id="system-error-message">
                <p id="system-error-message-p">{{"system-error.message" | translate}}</p>
              </div>              
              <div id="unrecoverable-error-message">
                <p id="unrecoverable-error-message-p">{{"unrecoverable-error.message" | translate}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer class="row copyRight-contactUs" id="copyRight-contactUs">
      <span id="copyrightMessage">{{copyrightMessage}}</span>
    </footer>
  </div>
  
  